import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, DatePicker } from "antd";
import "./Form.css";
import InputForm from "./InputForm";
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone"; // VALIDAR DATAS

import CtaCorrenteFrame from './CtaCorrenteFrame';
import PlanoCtaFrame from './PlanoCtaFrame';
import TipoDocFrame from './TipoDocFrame';
import PessoaFrame from './PessoaFrame';
import ContratosFrame from '../components/ContratosFrame';
import UsuarioFrame from './UsuarioFrame';

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Item: ItemForm } = Form;

export const OPCOES_COMBO = [
  {
    key: 'X',
    label: 'Todos os Tipos'
  },
  {
    key: 'E',
    label: 'Entrada'
  },
  {
    key: 'S',
    label: 'Saída'
  },
]

export const OPCOES_COMBO_PARC = [
  {
    key: 'X',
    label: 'Todas as Situações'
  },
  {
    key: 'A',
    label: 'Aberto'
  },
  {
    key: 'P',
    label: 'Pago'
  },
]

export default class TituloFiltroForm extends Component {
  state = {
    registroFiltros: {
      tipoTela: '',
      buscaDataIni: '',
      buscaDataFim: '',
      buscaControle: '',
      buscaNumero: '',
      buscaDescricao: '',
      buscaTipo: { key: 'X' },
      buscaSituacao: { key: 'X' },
      buscaPessoa: { key: '0' },
      buscaPlanoCta: { key: '0' },
      buscaCtaCorrente: { key: '0' },
      buscaTipoDoc: { key: '0' },
      buscaContrato: { key: '0' },
      buscaUsuario: { key: '0' },
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.filtros !== propsAnterior.filtros) {
      this.setState({
        registroFiltros: this.props.filtros,
      }, () => {
        // this.refs.ven_pessoa.focus();
      });
    }
  }




  onOK = () => {
    // console.log('onOK: ', this.state.registroFiltros);
    this.props.onFiltrarClick(this.state.registroFiltros);
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroFiltros } = this.state;
    registroFiltros[id] = value;
    this.setState({
      [id]: value
    });
  };


  onChangeCtaCorrente = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaCtaCorrente'] = event.buscaCtaCorrente;
    this.setState(event);
  }

  onChangePlanoCta = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaPlanoCta'] = event.buscaPlanoCta;
    this.setState(event);
  }

  onChangeTipoDoc = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaTipoDoc'] = event.buscaTipoDoc;
    this.setState(event);
  }

  onChangePessoa = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaPessoa'] = event.buscaPessoa;
    this.setState(event);
  }

  onChangeContratos = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaContrato'] = event.buscaContrato;
    this.setState(event);
  }


  onChangePeriodo = event => {
    const { registroFiltros } = this.state;
    if (event[0]) {
      registroFiltros.buscaDataIni = moment(event[0]._d).format('DD/MM/YYYY');
      registroFiltros.buscaDataFim = moment(event[1]._d).format('DD/MM/YYYY');
    } else {
      registroFiltros.buscaDataIni = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY');
      registroFiltros.buscaDataFim = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY');
    }
    this.setState({
      registroFiltros
    },
      this.getListaRegistros
    );
  };

  onChangeVendedor = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaUsuario'] = event.buscaUsuario;
    this.setState(event);
  }




  render() {
    const { onCancelarFiltroClick, visivel } = this.props;
    const { tipoTela, buscaDataIni, buscaDataFim, buscaSituacao, buscaNumero, buscaControle,
      buscaTipo, buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaDescricao, buscaTipoDoc,
      buscaContrato, buscaUsuario
    } = this.state.registroFiltros;

    // console.log('TituloFiltroForm.this.state: ', this.state);

    return (
      <Modal
        title={"Filtro"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarFiltroClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <Row>
          <Col xs={15} style={{ marginRight: 30 }}>
            <span>Período</span>
            <RangePicker
              style={{ width: "102%" }}
              masker={maskDate}
              value={[moment(buscaDataIni, dateFormat), moment(buscaDataFim, dateFormat)]}
              format={dateFormat}
              allowClear={false}
              onChange={this.onChangePeriodo}
            />
          </Col>
          <Col xs={24} sm={8} style={{ marginTop: -3 }} className="camposEspacoDireita">
            <span>Controle</span>
            <InputForm
              id="buscaControle"
              ref="buscaControle"
              value={buscaControle}
              onChange={this.onChange}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
            <span>Numero</span>
            <InputForm
              id="buscaNumero"
              ref="buscaNumero"
              value={buscaNumero}
              onChange={this.onChange}
              style={{ width: "100%" }}
            />
          </Col>
          {tipoTela === 'CX' || tipoTela === 'BAL' || tipoTela === 'REP' ? null : (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Situação</span>
              <InputForm
                type="select"
                id="buscaSituacao"
                ref="buscaSituacao"
                value={buscaSituacao}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_PARC}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
          )}
          {tipoTela === 'BAL' || tipoTela === 'CTRPGTO' ? null : (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Tipo</span>
              <InputForm
                type="select"
                id="buscaTipo"
                ref="buscaTipo"
                value={buscaTipo}
                placeholder="Selecione o Tipo"
                onChange={this.onChange}
                data={OPCOES_COMBO}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
          )}
          {tipoTela === 'FFI' || tipoTela === 'CTRPGTO' ? null : (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <PessoaFrame
                label="Cliente/Fornecedor"
                id="buscaPessoa"
                value={buscaPessoa}
                width={"100%"}
                onChange={this.onChangePessoa}
                descricaoPrimeiroItem="Todos os Clientes/Fornecedore"
              />
            </Col>
          )}
          {tipoTela === 'CTRPGTO' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <ContratosFrame
                label="Contratos"
                id="buscaContrato"
                value={buscaContrato}
                width={"100%"}
                onChange={this.onChangeContratos}
                descricaoPrimeiroItem="Selecione um Contrato"
              />
            </Col>
          ) : null}
          {tipoTela === 'CTRPGTO' ? null : (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <PlanoCtaFrame
                label="Conta Financeira"
                id="buscaPlanoCta"
                value={buscaPlanoCta}
                width={"100%"}
                onChange={this.onChangePlanoCta}
                descricaoPrimeiroItem="Todas as Contas Financeiras"
              />
            </Col>
          )}
          {tipoTela === 'TIT' || tipoTela === 'REP' || tipoTela === 'FFI' || tipoTela === 'CTRPGTO' || tipoTela === 'CPR' ? null : (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <CtaCorrenteFrame
                label="Conta Corrente"
                id="buscaCtaCorrente"
                value={buscaCtaCorrente}
                width={"100%"}
                onChange={this.onChangeCtaCorrente}
                descricaoPrimeiroItem="Todas as Contas Correntes"
              />
            </Col>
          )}
          {tipoTela === 'TIT' || tipoTela === 'REP' || tipoTela === 'FFI' || tipoTela === 'CTRPGTO' || tipoTela === 'CPR' ? null : (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <TipoDocFrame
                label="Tipo Documento"
                id="buscaTipoDoc"
                value={buscaTipoDoc}
                width={"100%"}
                onChange={this.onChangeTipoDoc}
                descricaoPrimeiroItem="Todos os Tipos de Documentos"
              />
            </Col>
          )}
          {tipoTela === 'CTRPGTO' ? null : (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Descrição</span>
              <InputForm
                id="buscaDescricao"
                ref="buscaDescricao"
                value={buscaDescricao}
                onChange={this.onChange}
                style={{ width: "100%" }}
              />
            </Col>
          )}
          {tipoTela != 'CTRPGTO' ? null : (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <UsuarioFrame
                label="Vendedor"
                id="buscaUsuario"
                value={buscaUsuario}
                width={"100%"}
                vendedor={1}
                onChange={this.onChangeVendedor}
                descricaoPrimeiroItem="Todos os Vendedores"
              />
            </Col>
          )}
        </Row>

        <div>
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={this.onOK}
                  className="btn-salvar"
                >
                  Filtrar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarFiltroClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TituloFiltroForm.js